module.exports = __webpack_public_path__ + "img/grandparent-love-handsign.4ac1bd35.png";